import { Box, Drawer, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type BaseDrawerProps = {
    open: boolean;
    anchor?: 'left' | 'right' | 'top' | 'bottom';
    title?: string;
    children: ReactNode;
    footer?: ReactNode;
    onClose: () => void;
    onExited?: () => void;
    showCloseButton?: boolean;
    maxWidth?: number | string;
    onEnter?: () => void;
};

const BaseDrawer = ({
    open,
    anchor = 'bottom',
    title,
    children,
    footer,
    onClose,
    onExited,
    onEnter,
}: BaseDrawerProps) => {
    return (
        <Drawer
            anchor={anchor}
            open={open}
            onClose={onClose}
            ModalProps={{
                keepMounted: true,
                disableRestoreFocus: true,
            }}
            SlideProps={{
                onExited,
                onEnter,
            }}
            PaperProps={{
                sx: {
                    width: '100%',
                    mx: 'auto',
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    overflow: 'hidden',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '95dvh',
                }}
            >
                {title && (
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                        sx={{
                            px: 2,
                            py: 1.5,
                            borderBottom: '1px solid #E5E7EB',
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 800,
                                color: '#111827',
                            }}
                        >
                            {title}
                        </Typography>
                    </Stack>
                )}

                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: 'auto',
                        px: 2,
                        py: 2,
                    }}
                >
                    {children}
                </Box>

                {footer && (
                    <Box
                        sx={{
                            px: 2,
                            pt: 1,
                            pb: 'calc(16px + env(safe-area-inset-bottom))',
                            borderTop: '1px solid #E5E7EB',
                        }}
                    >
                        {footer}
                    </Box>
                )}
            </Box>
        </Drawer>
    );
};

export default BaseDrawer;
